import React from "react";

import TopHeader from "components/the-buzz-theme/header/top-header";
import { Header } from "components/the-buzz-theme/header/header";
import { Footer } from "components/the-buzz-theme/footer/footer";
import { SVGList } from "components/the-buzz-theme/svg-list/svg-list";
import { Main } from "components/the-buzz-theme/main/main";

import { ResolvedType } from "interfaces";
import { RootQueryToPostConnection } from "interfaces/wordpress";
import { getRecentCategoryPosts } from "lib/api";
import Slider from "components/the-buzz-theme/slider/slider";
import PostFeed from "components/the-buzz-theme/post-feed/post-feed";

export type Props = {
  stickyPosts?: RootQueryToPostConnection;
  recentPosts?: ResolvedType<typeof getRecentCategoryPosts>;
  recentPostsTotal?: number;
  color?: string;
  categoryName?: string;
  tags?:
    | undefined
    | {
        name: string;
        count: number;
        slug: string;
      }[];
};

export default function CategoryPage(props: Props) {
  return (
    <>
      <SVGList />
      <TopHeader />
      <Header tags={props.tags} backgroundColor={props.color} />
      <Main backgroundColor={props.color}>
        <div className="container-xxl">
          {props.recentPosts?.name ? (
            <div className="entry-header">
              <h1 className="entry-title">{props.recentPosts.name}</h1>
            </div>
          ) : null}

          {props.stickyPosts?.nodes.length ? (
            <Slider stickyPosts={props.stickyPosts} />
          ) : null}

          <PostFeed
            id={""}
            categoryName={props.categoryName}
            posts={props.recentPosts}
            total={props.recentPostsTotal}
            sectionClassname={"entry-content"}
          />
        </div>
      </Main>
      <Footer />
    </>
  );
}
